import React from "react";
import TakeABreakNav from "./Navs/TakeABreakNav";
// import LearnerElearningNav from './Navs/LearnerElearningNav';

const LearnerMenu = (props) => {
  return (
    <>
      {/* <LearnerElearningNav context={props.context} manipulateColours={props.manipulateColours} /> */}
      <TakeABreakNav context={props.context} />
    </>
  );
};

export default LearnerMenu;
